import Box from '@mui/material/Box'
import { useEffect, useState } from 'react'

import { AuthService } from '../../services/auth.service'
import { TokenCard } from './components/TokenCard'

export const ShowTokenContainer = () => {
  const [idToken, setIdToken] = useState<string>('')
  const [accessToken, setAccessToken] = useState<string>('')

  useEffect(() => {
    const getTokens = async () => {
      try {
        const session = await AuthService.getCurrentSession()
        if (session) {
          setIdToken(session.getIdToken().getJwtToken())
          setAccessToken(session.getAccessToken().getJwtToken())
        }
      } catch (error) {
        console.error('Error getting tokens:', error)
      }
    }

    getTokens()
  }, [])

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '24px',
        gap: '24px'
      }}>
      <TokenCard title="ID Token" token={idToken} />
      <TokenCard title="Access Token" token={accessToken} />
    </Box>
  )
}
